module.exports = __webpack_public_path__ + "static/media/icon-clock.8ea3b764.svg";